module.exports = __webpack_public_path__ + "feedbackmodule/img/logo_t2evolve.4bbb5edf.png";